import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {Modal} from '@softline/ui-core';
import { PrintPayload } from '../../data/print-payload';


import { CheckboxComponent } from '@softline/ui-core';
import { DateInputComponent } from '@softline/ui-core/date-input';
@Component({
    selector: 'app-print-config-dialog',
    imports: [
    CheckboxComponent,
    DateInputComponent
  ],
    templateUrl: './print-config-dialog.component.html',
    styleUrls: ['./print-config-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintConfigDialogComponent implements OnInit, Modal<PrintPayload | null> {

  // tslint:disable-next-line:variable-name
  valid_from!: string;
  conditionSheet2 = false;
  includePrice = false;

  close!: (result: PrintPayload | null) => void;

  constructor() { }

  ngOnInit(): void {}

  registerCloseHandler(handler: (result: PrintPayload | null) => void) {
    this.close = handler;
  }

  closeAndPrint(): void {
    this.close({
      valid_from: this.valid_from,
      conditionSheet2: this.conditionSheet2,
      includePrice: this.includePrice
    });
  }
}
